import { Store } from 'svelte/store.js';
import { truthy, defaultScrollDelay } from './helpers';


const store = new Store({
    loading: true,
    muted: false,
    playing: new Set(),
    direction: 'down',
    scroll_hint: false,
    scroll_hint_delay: 8000,
    modal_active: false,
    gallery_prompt_display: true,
    
    cover_active: true,
    index_active: false,
    index_chapter: 'izerman',
    chapter_index: [],

    MEDIA_HOST: window.MEDIA_HOST,
    isMobile: window.isMobile,
    bowser: window.bowser,

    // chapters
    intro: [],
    izerman: [],
    julia: [],
    wilmer: [],
    chapters: ['intro', 'izerman', 'julia', 'wilmer'],
    current_chapter: 'intro',
    current_slide: 0,
    slides: [], // computed below

    BASE_URL: window.location.href,
});

store.compute('slides', 
    ['intro', 'izerman', 'julia', 'wilmer', 'current_chapter'],
    (intro, izerman, julia, wilmer, current_chapter) => {
        const chapters = { intro, izerman, julia, wilmer };

        return chapters[current_chapter] || [];
    });

store.compute('next_chapter', 
    ['current_chapter', 'chapters'],
    (current_chapter, chapters) => {
        if(chapters[chapters.indexOf(current_chapter) + 1]) return chapters[chapters.indexOf(current_chapter) + 1];
        return false;
    });

store.compute('scroll_hint', 
    ['slides', 'current_slide', 'cover_active'],
    (slides, current_slide, cover_active) => {
        if (cover_active) return false;
        if (truthy(slides[current_slide].auto_advance) || truthy(slides[current_slide].scroll_hint_special)){
            return false;
        }
        return true;
    });

store.compute('scroll_hint_delay', 
    ['slides', 'current_slide', 'cover_active'],
    (slides, current_slide, cover_active) => {
        if (cover_active) return defaultScrollDelay;
        if (slides[current_slide].scroll_hint_delay) return parseInt(slides[current_slide].scroll_hint_delay);
        return defaultScrollDelay;
    });

export default store;